<template>
  <div class="favicon-settings brdr_content_wrpr">
    <h3 class="brdr_content_title">Favicon</h3>
    <loading v-show="loading"></loading>
    <div class="layout-row clickable-section" @click="isOpen = true">
      <div class="flex">
        <p style="font-weight: 600;">Favicon</p>
	      <p>This is the favicon that will be associated with all pages in your funnel (<i>Make sure it's square</i>).</p>
      </div>
      <div class="flex-none right-panel" style="min-width: 150px">
        <span v-if="funnel.favicon" class="label" style="">
          <img :src="funnel.favicon" />
        </span>
	      <span v-else class="label" style="">
          <img :src="require('@/assets/img/logo.svg')" />
        </span>
      </div>
    </div>

	  <portal to="popup">
		  <select-image-popup v-if="isOpen" :funnel-id="funnel.id" @close="isOpen=false" @done="setImage($event)"  />
	  </portal>

  </div>
</template>

<script>
import ConnectSmtpPopup from "@/components/popups/connect_smtp_popup";
import Loading from "@/components/Loading";
import API from "@/api"
import SelectImagePopup from "@/modules/page-editor/src/components/popups/SelectImagePopup";

export default {
    name: 'FaviconSettings',
  props: ["funnel"],
  mixins: [API],
  components: {SelectImagePopup, Loading, ConnectSmtpPopup},
  data: function (){
      return {
        loading: false,
        isOpen: false,
      }
  },
  computed: {
    integrationId() {
      if (this.funnel) {
        return this.funnel.smtp_integration_id;
      }
      return 0;
    }
  },
  mounted() {
  },
  methods: {
      async setImage(img) {
        try {
        	this.isOpen = false;
        	this.funnel.favicon = `//img.funnelish.com/${img.path}` // ?auto=webp&fit=bounds&width=160&height=160
        } catch (e) {
          this.$error(e)
        }
      },
    onSMTPSelected(smtp) {
      this.openConnectSmtpPopup = false;
      this.funnel.smtp_integration_id = Number(smtp.id);
      this.integration = smtp;
    },
  }
}
</script>

<style lang="scss">
.clickable-section {
  border-top: 1px solid whitesmoke;
  border-bottom: 1px solid whitesmoke;
  padding: 0 10px;
  cursor: pointer;
  background: white;
  pointer-events: auto;
  transition: .2s all ease-in-out;

  &:hover {
    background: #f6f9fd;
    border-top: 1px solid #4268df;
    border-bottom: 1px solid #4268df;

    .label {
      color: #4268df;
    }
  }
  .right-panel {
    position: relative;
    display: flex;

    > .label {
      font-weight: bold;
      margin: auto;
      display: flex;
      > img {
        margin-right: 10px;
        height: 40px;
        width: 40px;
      }
    }
  }
}
</style>
